import classNames from 'classnames'

import { Icon } from '@paysense-india-services/elevate-web'

import { useScreenSize } from '@/hooks/useScreenSize'

import styles from './index.module.scss'

const Header = ({
  icon = {
    name: 'cross',
    fillColor: '#171717'
  },
  title,
  leftComponent: LeftComp,
  middleComponent: MidComp,
  rightComponent: RightComp,
  onLeftIconClick,
  customClass,
  hideOnDesktop = false
}) => {
  const { isDesktop, isLoaded } = useScreenSize()

  if (hideOnDesktop && (isDesktop || !isLoaded)) {
    return null
  }
  return (
    <>
      <div
        className={classNames(
          styles.headerContainer,
          customClass,
          'ew-d-flex',
          'ew-align-items-center',
          'ew-justify-content-between',
          'ew-p-12',
          'ew-bg-primary',
          'ew-position-fixed',
          'ew-w-100'
        )}>
        <div className='ew-d-flex ew-align-items-center'>
          <div
            className={classNames(styles.leftSection, 'ew-mr-8', 'ew-cursor-pointer')}
            onClick={onLeftIconClick}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onLeftIconClick?.()
              }
            }}
            role='button'
            tabIndex={0}>
            {LeftComp ? (
              <LeftComp />
            ) : (
              <Icon fill={icon.fillColor} id='header-nav-icon' name={icon.name} size={24} />
            )}
          </div>
          {MidComp ? (
            <MidComp />
          ) : (
            <div className='ew-typography-normal ew-fw-semi-bold'>{title}</div>
          )}
        </div>
        {RightComp ? (
          <div className='ew-ml-8'>
            <RightComp />
          </div>
        ) : null}
      </div>
      <div className={styles['headerFiller']} />
    </>
  )
}

export default Header
